module.exports = __webpack_public_path__ + "img/nose-01.d5ef808b.svg";